module.exports = __webpack_public_path__ + "static/media/phone_iphone_black_24dp.a1a67115.svg";